import React from "react";
import areaProtegida from "../Images/area_protegida.webp";
import ButtonArrow from "../components/ButtonArrow";
import CarouselComponent from "../components/CarouselComponent";
import { Helmet } from "react-helmet";

const PortectedArea = () => {
  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Área Protegida Rincón de la Franquía – Naturaleza y Biodiversidad en Bella Unión</title>
        <meta
          name="description"
          content="Explora el área protegida de Bella Unión, un entorno natural con biodiversidad única, senderos y paisajes ideales para conectar con la naturaleza."
        />
        <meta
          name="keywords"
          content="área protegida Bella Unión, naturaleza Bella Unión, biodiversidad Uruguay, senderismo Bella Unión, turismo ecológico"
        />
        <link rel="canonical" href="https://bellaunion.uy/area-protegida" />
        <meta
          property="og:title"
          content="Área Protegida Rincón de la Franquía – Naturaleza y Biodiversidad en Bella Unión"
        />
        <meta
          property="og:description"
          content="Explora el área protegida de Bella Unión, un entorno natural con biodiversidad única, senderos y paisajes ideales para conectar con la naturaleza."
        />
        <meta property="og:url" content="https://bellaunion.uy/area-protegida" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={areaProtegida} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Área Protegida Rincón de la Franquía – Naturaleza y Biodiversidad en Bella Unión"
        />
        <meta
          name="twitter:description"
          content="Explora el área protegida de Bella Unión, un entorno natural con biodiversidad única, senderos y paisajes ideales para conectar con la naturaleza."
        />
        <meta name="twitter:image" content={areaProtegida} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Área Protegida</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container">
          <div className="row g-0 d-flex align-items-stretch py-5">
            <div className="col-lg-5 order-lg-0 order-1 bg-white rounded shadow d-flex align-items-center">
              <div className="p-5 text-center">
                <h2>Rincón de Franquía: Un Tesoro Natural en Uruguay</h2>
                <p>
                  Rincón de Franquía es un área protegida de manejo de hábitats y especies, ubicada en
                  Uruguay. Con 1.150 hectáreas de exuberante biodiversidad, este espacio es el hogar de más
                  del 50% de las especies de aves presentes en el país, convirtiéndolo en un destino
                  imperdible para los amantes de la naturaleza.
                </p>
                <h5>Un Refugio para la Biodiversidad</h5>
                <p>
                  Gracias a la iniciativa de la Sociedad Civil GruPaMa, un grupo comprometido con la
                  conservación ambiental, el Rincón de Franquía se ha convertido en un modelo de protección
                  ecológica. Su labor destaca por la preservación de hábitats clave y la promoción de
                  prácticas sostenibles.
                </p>
                <h5>Explora y Descubre</h5>
                <p>Los visitantes pueden recorrer senderos guiados y autoguiados, ideales para:</p>
                <ul>
                  <li>Observar aves y otras especies en su entorno natural.</li>
                  <li>Aprender sobre la flora y fauna local a través de una experiencia educativa.</li>
                  <li>Conocer de cerca los esfuerzos de conservación que se realizan en la zona.</li>
                </ul>
                <p>
                  El Rincón de Franquía es mucho más que un área protegida: es un espacio donde la naturaleza
                  y la conciencia ambiental se encuentran, ofreciendo a cada visitante una conexión única con
                  el entorno.
                </p>
                <h4 className="text-center">¿Listo para descubrir este paraíso natural?</h4>
              </div>
            </div>
            <div className="col-lg-7 order-lg-1 order-0 d-flex">
              <img
                src={areaProtegida}
                alt="area protegida"
                className="img-fluid rounded-end shadow my-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PortectedArea;
